import { getApiBase } from "../../lib/api";

export interface CartItem {
  id: string;
  name: string;
  price: number;
  quantity: number;
  image_url: string;

  variant_id?: string | null;
  size_label?: string | null;
}

export interface ShippingData {
  to_name: string;
  to_address: string;
  to_city: string;
  to_state: string;
  to_zip: string;
  to_country: string;

  phone_number: string;
  email?: string | null;

  rate_object_id: string;

  shipping_rate?: number | null;

  carrier?: string | null;
  label_url?: string | null;
  tracking_number?: string | null;
}

export type StripeTotals = {
  subtotal_cents: number;
  shipping_cents: number;
  tax_cents: number;
  total_cents: number;
  stripe_tax_calculation_id?: string;
  stripe_payment_intent_id?: string;
};

export const saveOrderToSupabase = async (
  cart: CartItem[],
  shippingData: ShippingData,
  totals: StripeTotals,
  userId?: string | null
) => {
  const res = await fetch(`${getApiBase()}/checkout/submit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      cart,
      shippingData,
      userId: userId ?? null,
      totals,
    }),
  });

  let body: any = null;

  try {
    body = await res.json();
  } catch {
    body = null;
  }

  if (!res.ok) {
    console.error("❌ Failed to save order (response):", body);
    throw new Error(body?.error || body?.message || "Failed to save order.");
  }

  return body;
};
